import React, { useEffect, useState } from 'react';
import Autocomplete from '../Autocomplete';
import { routing as routingApi } from '@afosto/wms/api/Routing';
import currentUnixTimestamp from '@afosto/utils/date/currentUnixTimestamp';

const RoutesSearch = ({ name, label, ...otherProps }) => {
  const [routes, setRoutes] = useState([]);
  const [isFetchingRoutes, setIsFetchingRoutes] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const fetchRoutes = async () => {
      setIsFetchingRoutes(true);
      try {
        const options = {
          headers: {
            'x-page-size': 250,
          },
        };

        const { data } = await routingApi.getRoutes({ deletedAt: currentUnixTimestamp() }, options);
        if (isMounted) {
          setRoutes(data);
        }
      } catch (error) {
        //  do something
      } finally {
        setIsFetchingRoutes(false);
      }
    };

    fetchRoutes();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Autocomplete
      {...otherProps}
      name={name}
      label={label}
      options={routes.map(route => ({
        ...route,
        label: route.name,
        value: route.id,
      }))}
      loading={isFetchingRoutes}
    />
  );
};

RoutesSearch.propTypes = Autocomplete.propTypes;

RoutesSearch.defaultProps = Autocomplete.defaultProps;

export default RoutesSearch;
